import { createFileRoute, getRouteApi } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { AuditTimelinePage } from '@/components/audit/AuditTimeline';
import { useSetTitle } from '@/stores/title-context';

const routeApi = getRouteApi('/_authenticated/_app/settings/audit/timeline/$targetType/$targetId');

function AuditTimelineRoute() {
	const { t } = useLingui();
	useSetTitle(t`Audit Timeline`);
	const { targetType, targetId } = routeApi.useParams();
	return <AuditTimelinePage targetType={targetType} targetId={targetId} />;
}

export const Route = createFileRoute('/_authenticated/_app/settings/audit/timeline/$targetType/$targetId')({
	component: AuditTimelineRoute,
});
